import { useState } from "react";
import { Link } from "react-router-dom";
import API, { formatApiError } from "../lib/api";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Reset link sent if email exists.");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F0F0F0] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#00FF41] mb-8 transition-colors" data-testid="forgot-back">
          <ArrowLeft size={14} /> Back to Login
        </Link>
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-2" data-testid="forgot-title">Reset Password</h1>
        <p className="text-sm text-slate-500 mb-8">Enter your email and we'll send you a reset link.</p>

        {sent ? (
          <div className="p-4 bg-[#00FF41]/10 border border-[#00FF41]/30 text-sm text-[#00FF41]" data-testid="forgot-success">
            If an account with that email exists, a password reset link has been sent. Check your email (or server logs if SendGrid is not configured).
          </div>
        ) : (
          <>
            {error && <div className="mb-4 p-3 bg-red-900/30 border border-red-800 text-sm text-red-400" data-testid="forgot-error">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-1.5 block">Email</label>
                <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                  className="w-full bg-[#111111] border border-[#1E1E1E] px-4 py-3 text-sm text-[#F0F0F0] focus:outline-none focus:border-[#00FF41] transition-colors"
                  data-testid="forgot-email-input" />
              </div>
              <button type="submit" disabled={loading}
                className="w-full bg-[#00FF41] text-[#0A0A0A] py-3 text-sm font-bold hover:bg-[#00CC33] transition-colors disabled:opacity-50"
                data-testid="forgot-submit-button">
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
